import { UserInfo } from 'app/hupassApi';
import { atom } from 'recoil';

export const userInfoState = atom<UserInfo | undefined>({
  key: 'userInfo',
  default: undefined,
});
